export default "__VITE_ASSET__Dvj36I$9__"